module.exports = __webpack_public_path__ + "img/TRYY.d0fbb5ab.png";